import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=1bb1be4c&scoped=true&"
import script from "./ProfileSection.vue?vue&type=script&lang=js&"
export * from "./ProfileSection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSection.vue?vue&type=style&index=0&id=1bb1be4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1be4c",
  null
  
)

export default component.exports